export default {
    namespaced: true,
    alarm_groups: {
      title: "Alarm groups | Alarm group",
      name: 'Name',
      group: 'Group',
      select: 'Select one or more groups'
    },
};
